"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoricoMatrizRisco = void 0;
var HistoricoMatrizRisco = /** @class */ (function () {
    function HistoricoMatrizRisco(_a) {
        var _b = _a._id, _id = _b === void 0 ? '' : _b, _c = _a.nivelRisco, nivelRisco = _c === void 0 ? '' : _c;
        this._id = _id;
        this.nivelRisco = nivelRisco;
    }
    return HistoricoMatrizRisco;
}());
exports.HistoricoMatrizRisco = HistoricoMatrizRisco;
//# sourceMappingURL=HistoricoMatrizRisco.js.map